export function getCanceler() {
    return Object.preventExtensions({
        timmer: undefined,
        cancel: () => null,
    });
}

export default function sleep(time, canceler = getCanceler()) {
    return new Promise(function(resolve) {
        canceler.timmer = setTimeout(resolve, time);
        canceler.cancel = function() {
            clearTimeout(canceler.timmer);
        };
    });
}
